import { apiCall } from '../../context/api';

export const connectHubspot = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/crm-oauth/HUB?req_type=${type}`);
  return data.redirect_url;
};

export const connectGhl = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/crm-oauth/GHL?req_type=${type}`);
  return data.redirect_url;
};

export const connectPipedrive = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/crm-oauth/PIPE?req_type=${type}`);
  return data.redirect_url;
};

export const connectSalesforce = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/crm-oauth/SF?req_type=${type}`);
  return data.redirect_url;
};

export const connectWise = async (baseURL, token, credentials) => {
  return apiCall(baseURL, token, 'POST', '/core/onboarding/crm-connect/WISE', credentials);
};

export const connectQuickbooks = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/acct-oauth/QBO?req_type=${type}`);
  return data.redirect_url;
};

export const connectQuickbooksAlt = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/acct-oauth-alt/QBO?req_type=${type}`);
  return data.redirect_url;
};

export const connectXero = async (baseURL, token, type) => {
  const data = await apiCall(baseURL, token, 'GET', `/core/onboarding/acct-oauth/XERO?req_type=${type}`);
  return data.redirect_url;
};

export const stripeBillingPortal = async (baseURL, token) => {
  const data = await apiCall(baseURL, token, 'POST', '/core/webhooks/stripe/portal-session');
  return data.url;
};
